/** Longest side (px) a single image / sticker / video is displayed at: both dimensions are capped
 *  to this while preserving aspect (the old `max-h-80` = 20rem = 320px cap). */
export const MAX_MEDIA_PX = 320;

/** The display size of a single media item with known intrinsic dimensions: capped to
 *  `MAX_MEDIA_PX` on both sides, aspect kept. Used as a definite box that holds its space before
 *  the pixels arrive, so a late poster / frame never grows the thread under the reader. */
export function fitMedia(width: number, height: number): { width: number; height: number } {
  const scale = Math.min(MAX_MEDIA_PX / width, MAX_MEDIA_PX / height, 1);
  return { width: Math.round(width * scale), height: Math.round(height * scale) };
}
